import React, { useEffect } from 'react';
import { TripleAction } from '../../libs/gs-component-right-rail';
import useToast from '../../helpers/useToast';

import styles from './doubleActionWithError.scss';

interface Props {
  primaryOnClick: () => void;
  secondaryOnClick?: () => void;
  primaryText?: string;
  secondaryText?: string;
  primaryDisabled?: boolean;
  secondaryDisabled?: boolean;
  successText?: string;
  errorText?: string;
  showSpinner: boolean;
  showSuccess?: boolean;
  showError?: boolean;
  onHideSuccess?: Function;
  isPublished?: boolean;
}

const DoubleActionWithError: React.FC<Props> = ({
  primaryOnClick,
  secondaryOnClick = undefined,
  primaryText,
  secondaryText = undefined,
  primaryDisabled = false,
  secondaryDisabled = false,
  successText,
  errorText,
  showSpinner,
  showSuccess = false,
  showError = false,
  onHideSuccess,
  isPublished = false,
}) => {
  const [showSuccessToast, setShowSuccessToast] = useToast(2000, onHideSuccess);
  const [showErrorToast, setShowErrorToast] = useToast(7500);

  useEffect(() => {
    setShowSuccessToast(showSuccess);
  }, [showSuccess, setShowSuccessToast]);

  useEffect(() => {
    setShowErrorToast(showError);
  }, [showError, setShowErrorToast]);

  if (!primaryText) {
    primaryText = isPublished ? 'Save & publish' : 'Save';
  }

  return (
    <div>
      <TripleAction
        primaryOnClick={primaryOnClick}
        primaryText={primaryText}
        primaryDisabled={primaryDisabled}
        secondaryOnClick={secondaryOnClick || undefined}
        secondaryText={secondaryText || undefined}
        secondaryDisabled={secondaryDisabled}
        showSpinner={showSpinner}
      />
      {showErrorToast && <div className={`${styles.toast} ${styles.errorToast} ${styles.visible}`}>{errorText}</div>}
      {showSuccessToast && (
        <div className={`${styles.toast} ${styles.successToast} ${styles.visible}`}>{successText}</div>
      )}
    </div>
  );
};

export default DoubleActionWithError;
